import script from "./CurrentPayerPlanInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentPayerPlanInput.vue?vue&type=script&setup=true&lang=js"

import "./CurrentPayerPlanInput.vue?vue&type=style&index=0&id=0731e0ac&lang=css"

const __exports__ = script;

export default __exports__